import { useTranslation } from "react-i18next";

const statsData = [
  { icon: "ri-article-line", value: "500+", labelKey: "apropos.stats.stories", color: "text-orange-500", bg: "bg-orange-50" },
  { icon: "ri-global-line", value: "54", labelKey: "apropos.stats.countries", color: "text-green-600", bg: "bg-green-50" },
  { icon: "ri-team-line", value: "120K+", labelKey: "apropos.stats.readers", color: "text-yellow-600", bg: "bg-yellow-50" },
  { icon: "ri-share-line", value: "50K+", labelKey: "apropos.stats.shares", color: "text-pink-500", bg: "bg-pink-50" },
  { icon: "ri-lightbulb-line", value: "200+", labelKey: "apropos.stats.innovations", color: "text-purple-500", bg: "bg-purple-50" },
  { icon: "ri-women-line", value: "35%", labelKey: "apropos.stats.women", color: "text-rose-500", bg: "bg-rose-50" },
];

export default function StatsSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-[#fdf8f3]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="w-10 h-1 rounded-full bg-orange-500 mx-auto mb-3"></div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 font-serif">{t("apropos.stats.title")}</h2>
          <p className="text-gray-500 mt-2">{t("apropos.stats.subtitle")}</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {statsData.map((s) => (
            <div key={s.labelKey} className="bg-white rounded-2xl p-4 md:p-6 text-center border border-gray-100 hover:-translate-y-1 transition-transform duration-300">
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl mx-auto mb-2 md:mb-3 ${s.bg}`}>
                <i className={`${s.icon} text-xl md:text-2xl ${s.color}`}></i>
              </div>
              <div className="text-xl md:text-2xl font-bold text-gray-900 mb-1">{s.value}</div>
              <div className="text-xs text-gray-500 leading-snug">{t(s.labelKey)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
